function setupVisualDiscoveryHooks() {    
    console.log("setupVisualDiscoveryHooks");
    window.FastSimonVisualDiscovery.registerHook('visual-discovery-gallery-products', ({ element, products }) => {
        console.log(element);

        // Find the modal containing the style-grid 
        const modal = element.closest('.modal-inner');

        const wrapper = element.closest('.product-results-wrapper');
        const mainImage = wrapper?.querySelector('.left-preview .main-image');

        // Find the modal header text 
        const modalHeaderText = modal?.querySelector('.modal-header-text');         
        console.log("modalHeaderText:", modalHeaderText); 
        console.log("modalHeaderText value:", modalHeaderText?.textContent.trim());
        if (modalHeaderText) {
            modalHeaderText.textContent = 'Shop Similar Styles';
        }
        

        if (mainImage && mainImage.src.includes('_small')) {
            mainImage.src = mainImage.src.replace('_small', '_large');
        }                 
        
    });

  window.FastSimonVisualDiscovery.registerHook('visual-discovery-modal', ({ element, galleryImages }) => {
    const title = element.querySelector('.title-text')
    if (title) title.innerHTML = window.fastSimonStrings.popup_title

    const subtitle = element.querySelector('.sub-title')
    if (subtitle) subtitle.innerHTML = window.fastSimonStrings.popup_subtitle

    const galleryDescription = element.querySelector('.galleryDescription')
    if (galleryDescription) galleryDescription.innerHTML = window.fastSimonStrings.gallery_description

    const uploadSubdescription = element.querySelector('.upload-area .sub-description')
    if (uploadSubdescription) uploadSubdescription.innerHTML = window.fastSimonStrings.upload_sub_description

    const uploadText = element.querySelector('.upload-area .sub-title-bold')
    if (uploadText) uploadText.innerHTML = window.fastSimonStrings.upload_text

    const uploadButton = element.querySelector('.upload-area .photo-button span')
    if (uploadButton) uploadButton.innerHTML = window.fastSimonStrings.upload_button

    const uploadMobileButton = element.querySelector('.actions-wrapper .upload-button span')
    if (uploadMobileButton) uploadMobileButton.innerHTML = window.fastSimonStrings.upload_mobile

    const takeMobileButton = element.querySelector('.actions-wrapper .take-a-photo-button span')
    if (takeMobileButton) takeMobileButton.innerHTML = window.fastSimonStrings.take_mobile
  })

}

// Execute when Visual Discovery is ready
if (window.FastSimonVisualDiscovery || window.VisualDiscovery) {
    setupVisualDiscoveryHooks();
} else {
    window.addEventListener('fast-visual-discovery-ready', function() {
        setupVisualDiscoveryHooks();
    });
}